import { render } from "./DiagnosisManagementDetail.vue?vue&type=template&id=71b4da7b&scoped=true"
import script from "./DiagnosisManagementDetail.vue?vue&type=script&lang=js"
export * from "./DiagnosisManagementDetail.vue?vue&type=script&lang=js"

import "./DiagnosisManagementDetail.vue?vue&type=style&index=0&id=71b4da7b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Master-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b4da7b"]])

export default __exports__